//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class ParameterModel extends ModelBase {
      static readonly $typeName = 'ParameterModel';
      public dataType: string;
      public key: string;
      public name: string;
      public value: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/businessRule/models/ParameterModel.ts